import { Box, Skeleton } from '@internations/ds'
import { LayoutChildSkeleton } from '@app/registration/_components/layoutChildSkeleton'
import { ReactElement } from 'react'

export default function RegistrationPageSkeleton(): ReactElement {
    return (
        <>
            <Box>
                <Skeleton height="40px" />
            </Box>
            <LayoutChildSkeleton />
        </>
    )
}
